import React, { useEffect, useState } from "react";
import { FormateoFechaPara_yyyyMMdd, ObtieneParametros, TratamientoDeVariableBoolean } from "neftis7_apicaller/src/funciones/Varios";
import { CheckBox, DateBox, NumberBox, TextBox } from "devextreme-react";
import ComboAbmConMonedas from "../Compuestos/Combos/ComboAbmConMonedas";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { Column, FilterRow, Pager, Paging } from "devextreme-react/data-grid";
import { LVGridCarga } from "../Basicos/LVGridCarga";
import LV_ART_Articulos_SelectorSimple from "../Compuestos/Complejos/Articulos/LV_ART_Articulos_SelectorSimple";
import { function_VEN_ListasPrecios_Cabecera_Generar_JSON, function_VEN_ListasPrecios_Cabecera_Leer, function_VEN_ListasPrecios_Cabecera_Modificar } from "neftis7_apicaller/src/funciones/VEN/ListasPrecios/VEN_ListasPrecios_Cabecera";
import { function_VEN_ListasPrecios_Detalle_Generar_JSON, function_VEN_ListasPrecios_Detalle_Insertar, function_VEN_ListasPrecios_Detalle_Modificar } from "neftis7_apicaller/src/funciones/VEN/ListasPrecios/VEN_ListasPrecios_Detalle";

const VEN_ListasPrecios = (props) => {

  const [loading, setLoading] = useState(true);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");

  const [codigoListaPrecios, setCodigoListaPrecios] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [codigoMoneda, setCodigoMoneda] = useState("");
  const [cotizacion, setCotizacion] = useState(0);
  const [fechaComienzo, setFechaComienzo] = useState(new Date());
  const [fechaFin, setFechaFin] = useState(new Date());
  const [sinFin, setSinFin] = useState(true);
  const [multiPlanta, setMultiPlanta] = useState(true);
  const [multiEmpresa, setMultiEmpresa] = useState(true);
  const [esPorcentual, setEsPorcentual] = useState(false);
  const [codigoListaPreciosPorcentual, setCodigoListaPreciosPorcentual] = useState("");

  const [datosLP, setDatosLP] = useState([]);
  const [objetoParaAgregar, setObjetoParaAgregar] = useState([]);

  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false);
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false);
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false);
  const [importe, setImporte] = useState(0);
  const [importeIVA, setImporteIVA] = useState(0);
  const [importeTotal, setImporteTotal] = useState(0);

  const calcularIVA = (porcentaje) => {
    if (importe > 0) {
      setImporteIVA(parseFloat((importe * (porcentaje / 100)).toFixed(2)));
    }
  };

  const calcularNetoIVA = () => {
    let totalStr = prompt("Ingresá el TOTAL:");
    let ivaStr = prompt("Ingresá el PORCENTAJE DE IVA (por ejemplo: 21 para 21%):");
  
    let total = parseFloat(totalStr);
    let porcentajeIVA = parseFloat(ivaStr);
  
    if (isNaN(total) || total <= 0) {
      alert("El total ingresado no es válido.");
      return;
    }
  
    if (isNaN(porcentajeIVA) || porcentajeIVA <= 0) {
      alert("El porcentaje de IVA ingresado no es válido.");
      return;
    }
  
    const neto = total / (1 + (porcentajeIVA / 100));
    const iva = total - neto;
    
    setImporte(parseFloat(neto.toFixed(2)))
    setImporteIVA(parseFloat(iva.toFixed(2)))
    setImporteTotal(total)
  };

  const handleOnClick_Agregar = async () => {
    if (!objetoParaAgregar || Object.keys(objetoParaAgregar).length === 0) {
      alert("Debe seleccionar un artículo antes de agregar.");
      return;
    }

    if (objetoParaAgregar.CodigoArticulo === "") {
      alert("Debe seleccionar un Artículo antes de agregar.");
      return;
    }

    if (objetoParaAgregar.CodigoPresentacion === "") {
      alert("Debe seleccionar una Presentación antes de agregar.");
      return;
    }

    if (objetoParaAgregar.CodigoTamano === "") {
      alert("Debe seleccionar un Tamaño antes de agregar.");
      return;
    }

    if (objetoParaAgregar.CodigoUnidadMedida === "") {
      alert("Debe seleccionar una Unidad de Medida antes de agregar.");
      return;
    }

    if (importe <= 0) {
      alert("El importe Neto debe ser mayor a 0.");
      return;
    }

    try {
      // Crear el nuevo objeto con los datos actuales
      const nuevoArticulo = {
        CodigoArticulo: objetoParaAgregar.CodigoArticulo,
        CodigoPresentacion: objetoParaAgregar.CodigoPresentacion || "",
        CodigoTamano: objetoParaAgregar.CodigoTamano || "",
        CodigoUnidadMedida: objetoParaAgregar.CodigoUnidadMedida || "",
        ABM_ART_Articulos_Descripcion: objetoParaAgregar.Articulo || "",
        ABM_ART_Presentaciones_Descripcion: objetoParaAgregar.Presentacion || "",
        ABM_ART_Tamanos_Descripcion: objetoParaAgregar.Tamano || "",
        ABM_ART_UnidadesMedida_Descripcion: objetoParaAgregar.UnidadMedida || "",
        Importe: importe,
        ImporteIVA: importeIVA,
        ImporteTotal: importeTotal
      };

      // Verificar si ya existe en la lista con la clave compuesta
      const existe = datosLP.some(
        (item) =>
          item.CodigoArticulo === nuevoArticulo.CodigoArticulo &&
          item.CodigoPresentacion === nuevoArticulo.CodigoPresentacion &&
          item.CodigoTamano === nuevoArticulo.CodigoTamano &&
          item.CodigoUnidadMedida === nuevoArticulo.CodigoUnidadMedida
      );

      const JSON = await function_VEN_ListasPrecios_Detalle_Generar_JSON(codigoListaPrecios, nuevoArticulo.CodigoArticulo,
        nuevoArticulo.CodigoPresentacion, nuevoArticulo.CodigoTamano, nuevoArticulo.CodigoUnidadMedida,
        nuevoArticulo.Importe, 0, 0, nuevoArticulo.ImporteIVA, 0,
        FormateoFechaPara_yyyyMMdd(new Date(fechaComienzo)), 0)

      if (existe) {
        await function_VEN_ListasPrecios_Detalle_Modificar(JSON)
        alert("Se ha modificado el precio.");
      }
      else {
        await function_VEN_ListasPrecios_Detalle_Insertar(JSON)
        alert("Se ha agregado el Artículo.");
      }

      window.location.reload()
    } catch (error) {
      alert("Se ha producido un error: " + error)
    }
  };

  const handleOnClick_Modificar = async () => {
    try {
      const JSON = await function_VEN_ListasPrecios_Cabecera_Generar_JSON(codigoListaPrecios, codigoMoneda,
        FormateoFechaPara_yyyyMMdd(new Date(fechaComienzo)), FormateoFechaPara_yyyyMMdd(new Date(fechaFin)),
        descripcion, multiPlanta, multiEmpresa, sinFin, esPorcentual, codigoListaPreciosPorcentual)
      await function_VEN_ListasPrecios_Cabecera_Modificar(JSON)

      alert("Se ha modificado la Lista de Precios.");

      window.location.reload()
    } catch (error) {
      alert("Se ha producido un error: " + error)
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const datosModificadores = await ObtieneParametros();
        setGlobalUsaArticulosConPresentacion(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion))
        setGlobalUsaArticulosConTamano(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano))
        setGlobalUsaArticulosConUnidadDeMedida(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida))
        setCodigoMoneda(datosModificadores.GlobalMonedaBase)

        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

        } else {
          setTituloBoton("ACTUALIZAR ID " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR ID " + props.Codigo.Codigo)

          setCodigoListaPrecios(props.Codigo.Codigo)

          const resultLP = await function_VEN_ListasPrecios_Cabecera_Leer(props.Codigo.Codigo, props.Codigo.FechaComienzo)
          const detallesConTotal = resultLP.data[0].Detalles.map(row => ({
            ...row,
            ImporteTotal: row.Importe + row.ImporteIVA
          }));

          setDatosLP(detallesConTotal)
          setCodigoMoneda(resultLP.data[0].CodigoMoneda)
          setDescripcion(resultLP.data[0].Descripcion)
          setFechaComienzo(resultLP.data[0].FechaComienzo)
          setFechaFin(resultLP.data[0].FechaFin)
          setSinFin(resultLP.data[0].SinFinalizacion)
        }

        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setImporteTotal(importe + importeIVA);
  }, [importe, importeIVA]);

  return (
    <>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div>
          <div className="LV-GroupBox-div" style={{ display: 'flex', marginBottom: '20px', alignItems: 'center', justifyContent: 'left', gap: '20px' }}>

            <TextBox label="Descripción" width={700} value={descripcion} onValueChanged={(e) => setDescripcion(e.value)} />

            Moneda
            <ComboAbmConMonedas onValueChanged={(e) => setCodigoMoneda(e.value)} value={codigoMoneda} />

            <DateBox label="Fecha Desde" displayFormat="dd/MM/yyyy" value={fechaComienzo} onValueChanged={(e) => setFechaComienzo(e.value)} width={120} />

            <CheckBox text="Sin Fin" value={sinFin} onValueChanged={(e) => setSinFin(e.value)} />

            <DateBox label="Fecha Hasta" displayFormat="dd/MM/yyyy" value={fechaFin} onValueChanged={(e) => setFechaFin(e.value)} width={120} visible={!sinFin} />

            <LVButtonAccion Texto="MODIFICAR" Ancho={136} style={{ marginLeft: 'auto' }} onClick={handleOnClick_Modificar} />
          </div>

          <div className="LV-GroupBox-div" style={{ display: 'flex', gap: '10px' }}>

            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
              <LV_ART_Articulos_SelectorSimple
                actualizarObjetoParaAgregar={setObjetoParaAgregar}
                tienePresentaciones={globalUsaArticulosConPresentacion}
                tieneTamanos={globalUsaArticulosConTamano}
                tieneUnidadesMedida={globalUsaArticulosConUnidadDeMedida} />

              <div style={{ marginTop: '15px', display: 'flex', gap: '15px', flexGrow: 1 }}>
                <NumberBox format="$ #,##0.##" label="Neto" width={150} value={importe} onValueChanged={(e) => setImporte(e.value)} />
                <NumberBox format="$ #,##0.##" label="I.V.A." width={150} value={importeIVA} onValueChanged={(e) => setImporteIVA(e.value)} />
                <NumberBox format="$ #,##0.##" label="Total" width={150} value={importeTotal} readOnly={true} />
                <LVButtonAccion Texto="CALCULAR I.V.A. 21%" onClick={() => calcularIVA(21)} />
                <LVButtonAccion Texto="CALCULAR I.V.A. 10.5%" onClick={() => calcularIVA(10.5)} />
                <LVButtonAccion Texto="CALCULAR NETO e I.V.A." onClick={() => calcularNetoIVA()} />

              </div>
            </div>

            <LVButtonAccion Texto="AGREGAR" Ancho={136} style={{ marginLeft: 'auto' }} onClick={handleOnClick_Agregar} />
          </div>

          <div className="LV-GroupBox-div" style={{ display: 'flex', marginTop: '20px', marginBottom: '7px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
            <LVGridCarga
              id="gridContainer"
              keyExpr="CodigoArticulo"
              keyExpr2="CodigoPresentacion"
              keyExpr3="CodigoTamano"
              keyExpr4="CodigoUnidadMedida"
              AnchoBotonera="38"
              allowEditing={false}
              allowDeleting={false}
              dataSource={datosLP}
              height={430}
            >
              <FilterRow visible={true} />

              <Column caption="Artículo" alignment="Center">
                <Column caption="Código" dataField="CodigoArticulo" width="80" alignment="Left" dataType="string" allowEditing={false} />
                <Column caption="Descripción" dataField="ABM_ART_Articulos_Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" allowEditing={false} />
                <Column caption="Presentación" dataField="ABM_ART_Presentaciones_Descripcion" width="80" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} allowEditing={false} />
                <Column caption="Tamaño" dataField="ABM_ART_Tamanos_Descripcion" width="80" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} allowEditing={false} />
                <Column caption="Unidad Medida" dataField="ABM_ART_UnidadesMedida_Descripcion" width="80" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} allowEditing={false} />
              </Column>
              <Column caption="Importes" alignment="Center">
                <Column caption="Neto" dataField="Importe" width="120" alignment="Right" dataType="number" format="currency" />
                <Column caption="I.V.A." dataField="ImporteIVA" width="120" alignment="Right" dataType="number" format="currency" />
                <Column caption="Total" dataField="ImporteTotal" width="120" alignment="Right" dataType="number" format="currency" allowEditing={false}/>
              </Column>
              <Paging defaultPageSize={9} />
              <Pager
                showPageSizeSelector={false}
              />
            </LVGridCarga>
          </div>
        </div >
      )}
    </>
  )
}

export default VEN_ListasPrecios;